import { useAuth } from "@/context/AuthContext";

export const MSG_SEM_RECURSO = "Recurso não incluído no seu plano.";

/** Benefícios efetivos da empresa (vêm em /auth/me). Sem lista = sem restrição (Master/legado). */
export const useRecurso = (chave) => {
  const { user } = useAuth();
  const lista = user?.recursos;
  return !Array.isArray(lista) || lista.includes(chave);
};
